import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ActionsListComponent} from "./actions-list.component";
import {TranslateModule} from "@ngx-translate/core";
import {ChappsListModule} from "@npm.chapps.com/chapps.common.angular.library";
import {BuildingComponentsModule} from "../../../buildings/components/building-components.module";
import {
  CompactBuildingCardComponent
} from "../../../buildings/components/building-summary/compact-building-card.component";



@NgModule({
  declarations: [
      ActionsListComponent,
      CompactBuildingCardComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ChappsListModule,
  ]
})
export class ActionsListModule { }
